<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import ResizeFullscreenIcon from '../icons/ResizeFullscreenIcon.svelte'
  import ResizeNormalIcon from '../icons/ResizeNormalIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
  import { THEMES } from '../../../const/themes'
  import { CONTROL_BAR_BUTTON_TOOLTIP_POSITION } from './ControlBarButton.svelte'
  import type { ControlBarButtonProps } from './ControlBarButton.svelte'

  let {
    tooltipPosition = CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER,
  }: Pick<ControlBarButtonProps, 'tooltipPosition'> = $props()
</script>

<ControlBarButton
  onclick={() => videoStore.state.videoController?.toggleFullscreen()}
  tooltip={translationsStore.state.fullscreen}
  {tooltipPosition}
  hidden={videoStore.state.isChromecasting}
  hoverColor={videoStore.state.isWebkitFullscreen
    ? componentAttributesStore.state.buttonsColor ||
      THEMES.DEFAULT.BUTTONS_COLOR
    : undefined}
>
  {#if videoStore.state.isFullscreen}
    <ResizeNormalIcon />
  {:else}
    <ResizeFullscreenIcon />
  {/if}
</ControlBarButton>
